module.exports = __webpack_public_path__ + "static/media/zurich.3254fdee.svg";